import clsx from 'clsx'
import { useEffect, useState } from 'react'
import { Link, useHistory, useParams } from 'react-router-dom'
import '../masters/basic.css'
import httpService from '../../setup/http/httpServices'
import { Input, message } from 'antd'
import Select from 'react-select'
import { KTSVG, toAbsoluteUrl } from '../../_metronic/helpers'
import _ from 'lodash'
import { handleFileUpload } from '../../setup/Upload/Upload'
import ComponentTopBreadCrumb from './ComponentTopBreadCrumb'
import { Category } from '@material-ui/icons'

interface Params {
    id: string;
}


const AddComponentFigmaComp = () => {
    const history: any = useHistory()
    const [loading, setLoading] = useState(false)
    const [counter, setCounter] = useState(Array(1).fill(0))
    const [phraseInput, setPhraseInput] = useState('')
    const [pages, setPages] = useState([{ value: '', label: 'Select Framework' }])
    const [values, setValues] = useState(
        {
            Category: { value: '', label: 'Select Framework' },
            componentMobileSS: '',
            componentDesktopSS: '',
            desktopCode: '',
            tabletCode: "",
            mobileCode: "",
            componentPhrases: []
        },
    )

    const params = useParams<Params>()
    const websiteId = params.id;

    const [errorArray, setErrorArray] = useState([false])
    const [loadingMob, setLoadingMob] = useState(false)
    const [loadingDesk, setLoadingDesk] = useState(false)
    const [fetchedDesk, setFetchedDesk] = useState(false)
    const [fetchedMob, setFetchedMob] = useState(false)
    const [deskfetchErr, setDeskFetchErr] = useState(false)
    const [mobfetchErr, setMobFetchErr] = useState(false)
    const [mobURL, setMobURL] = useState('')
    const [webURL, setWebURL] = useState('')
    const [desktopScreenshots, setDesktopScreenshots] = useState(null)

    const [categoryErr, setCategoryErr] = useState(false)
    const [desktopSsErr, setDesktopSsErr] = useState(false)
    const [mobileSsErr, setMobileSsErr] = useState(false)
    const [desktopCodeErr, setDesktopCodeErr] = useState(false)
    const [tabletCodeErr, setTabletCodeErr] = useState(false)
    const [mobileCodeErr, setMobileCodeErr] = useState(false)
    const [phrasesErr, setPhrasesErr] = useState(false)

    const [mobileScreenshots, setMobileScreenshots] = useState(null)
    const [manualWeb, setManualWeb] = useState(false)
    const [manualMob, setManualMob] = useState(false)
    const [previous, setPrevious] = useState(0)
    const [submitError, setSubmitError] = useState(false)
    const [subCategory, setSubCategory] = useState([])

    const [websites, setWebsites] = useState([])
    const [websiteOpt, setWebsiteOpt] = useState([{ value: '', label: 'Select Website' }])
    const [selectedWebsite, setSelectedWebsite] = useState<any>()

    const { TextArea } = Input;

    const onChange = async (event: any) => {
        // const d = await handleFileUpload(event, 675, 1200);
        const d = await handleFileUpload(event);
        setValues({ ...values, componentDesktopSS: d })
        setDesktopSsErr(false)
    }
    const onChangeMobile = async (event: any) => {
        // const d = await handleFileUpload(event, 400, 750);
        const d = await handleFileUpload(event);
        setValues({ ...values, componentMobileSS: d })
        setMobileSsErr(false)
    }

    const getData = async () => {
        let m = []
        httpService.getData(
            '/components-master',
            (res) => {
                console.log(res.data.data.data)
                let x = []
                res.data.data.data.forEach((data) => {
                    x.push({ value: data._id, label: data.Name })
                })
                m = x;
                setSubCategory(x)
                if (history.location.state?.edit) {
                    httpService.getData(
                        "/associated-component/" + history.location.state?.data._id,
                        (res) => {
                            const obj = {
                                componentPhrases: res.data.data.associatedComponent.componentPhrases,
                                Category: { value: res.data.data.associatedComponent.componentCategoryId, label: res.data.data.associatedComponent.componentCategoryName },
                                componentMobileSS: res.data.data.associatedComponent.componentMobileSS,
                                componentDesktopSS: res.data.data.associatedComponent.componentDesktopSS,
                                desktopCode: res.data.data.associatedComponent.desktopCode,
                                tabletCode: res.data.data.associatedComponent.tabletCode,
                                mobileCode: res.data.data.associatedComponent.mobileCode
                            }
                            setValues(obj)
                        },
                        (err) => {
                            console.log(err);
                        }
                    )
                }
            },
            (err) => {
                console.log(err)
            }
        )

    }

    useEffect(() => {
        getData()
    }, [])
    const submitForm = () => {
        console.log(values)
        if (!values.Category.value) {
            setCategoryErr(true)
            return;
        }
        if (!values.componentDesktopSS) {
            setDesktopSsErr(true)
            return;
        }
        if (!values.componentMobileSS) {
            setMobileSsErr(true)
            return;
        }
        if (!values.desktopCode) {
            setDesktopCodeErr(true)
            return;
        }
        if (!values.tabletCode) {
            setTabletCodeErr(true)
            return;
        }
        if (!values.mobileCode) {
            setMobileCodeErr(true)
            return;
        }
        if (!values.componentPhrases.length) {
            setPhrasesErr(true)
            return;
        }
        let EA = []


        const fd = {
            ...values,
            componentCategoryId: values.Category?.value,
            componentCategoryName: values.Category?.label,
            componentStatus: "FIGMA"
        }

        setErrorArray(EA)

        console.log(submitError, errorArray)
        setLoading(true)
        if (history.location.state?.edit) {
            httpService.patchData(
                '/associated-component/' + history.location.state?.data?._id,
                fd,
                (res) => {
                    const data = res.data.data
                    console.log(data)
                    message.success('Success!')
                    setLoading(false)
                    history.push('/website/add-components?componentType=FIGMA')
                },
                (err) => {
                    setLoading(false)
                    console.log(err)
                }
            )
        }
        else {
            httpService.postData(
                '/associated-component',
                fd,
                (res) => {
                    const data = res.data.data
                    console.log(data)
                    message.success('Success!')
                    setLoading(false)
                    history.push('/website/add-components?componentType=FIGMA')
                },
                (err) => {
                    setLoading(false)
                    console.log(err)
                }
            )
        }
    }


    const [nameError, setNameError] = useState(false)


    // useEffect(()=>{
    //     if(history.location.state?.edit){
    //         setValues(history.location.state?.data)
    //         console.log(history.location.state?.data);
    //         const obj = {
    //             componentPhrases:history.location.state?.data.componentPhrases,
    //             Category:{value:history.location.state?.data.componentCategoryId,label:history.location.state?.data.componentCategoryName},
    //             componentMobileSS:history.location.state?.data.componentMobileSS,
    //             componentDesktopSS:history.location.state?.data.componentDesktopSS,
    //             desktopCode:history.location.state?.data.desktopCode,
    //             tabletCode:history.location.state?.data.tabletCode,
    //             mobileCode:history.location.state?.data.mobileCode,
    //         }

    //     }
    // },[])

    return (
        <div>
            <ComponentTopBreadCrumb state={3} />
            <div className='CompanyDetailsOuter border '>
                <div
                    style={{ marginBottom: '200px' }}
                >


                    <div className='CompanyDetails'>
                        <div
                            className='p-4'
                            style={
                                (categoryErr || desktopSsErr || mobileSsErr)
                                    ? { borderRadius: '12px', border: '1px red solid' }
                                    : { borderRadius: '12px', border: '1px #eff2f5 solid' }
                            }
                        >
                            <div className='p-3' style={{ display: 'flex', gap: '20px', alignItems: 'end' }}>


                                <div className={'row'} style={{ width: '100%' }}>
                                    <div className='col '>
                                        <h6 className='fw-bold required'>Select Section Category</h6>
                                        <Select
                                            isMulti={false}
                                            name='Linked Pages'
                                            options={subCategory}
                                            onChange={e => {
                                                setValues({ ...values, Category: e })
                                                setCategoryErr(false)
                                            }}
                                            value={values.Category}
                                            placeholder='Select Category'
                                            styles={{
                                                menuList: (provided, state) => ({
                                                    ...provided,
                                                    height: 'auto',
                                                    maxHeight: '200px',
                                                }),
                                            }}
                                            className={clsx(
                                                'text-gray-500 form-control form-control-solid rounded-4 bg-gray-100 p-0 border-0 categorySelect'
                                            )}
                                        />
                                    </div>
                                </div>

                            </div>
                            <div className='separator my-4'></div>

                            <div className='m-2'>
                                <div className='pe-5 '>
                                    <div className='d-flex align-items-center justify-content-between'>
                                        <div>
                                            <h6 className='required fw-normal'>DesktopSS Section View</h6>
                                            {/* <p
                                                        className='text-gray-500'
                                                        style={deskfetchErr ? { color: 'red' } : { color: 'green' }}
                                                    >
                                                        {values[i].componentDesktopSS && 'Upload screenshot'}
                                                        {!values[i].componentDesktopSS && 'Uplaoded Screenshot'}
                                                        {manualWeb && 'Manually Uploaded'}
                                                    </p> */}
                                        </div>
                                        <div>
                                            <button
                                                type='button'
                                                className={
                                                    !values.componentDesktopSS
                                                        ? 'btn btn-gray-200 screenshotComponentBtn border border-gray-500'
                                                        : 'screenshotComponentBtn'
                                                }
                                                disabled={values.componentDesktopSS ? false : true}
                                                onClick={() => {
                                                    window.open(values.componentDesktopSS, '_blank')

                                                }}
                                            >
                                                {values.componentDesktopSS && (
                                                    <img src={toAbsoluteUrl('/media/icons/Custom/eye.svg')} alt='eye' />
                                                )}
                                                &nbsp; Preview
                                            </button>
                                            {!loadingDesk && (
                                                <button
                                                    type='button'
                                                    className='btn btn-gray-200 screenshotComponentBtn border border-gray-500 w-200px mx-4 cursor-pointer'
                                                    onClick={() => {
                                                        document.getElementById('desktopManual').click()
                                                    }}
                                                >
                                                    Click to {manualWeb ? 'Re-Uplaod' : 'Upload'}
                                                </button>
                                            )}
                                            <input
                                                type='file'
                                                accept='.png, .jpg, .jpeg, .svg'
                                                style={{ display: 'none' }}
                                                id={'desktopManual'}
                                                onChange={(e) => onChange(e)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='m-2 mt-5'>
                                <div className='pe-5 '>
                                    <div className='d-flex align-items-center justify-content-between'>
                                        <div>
                                            <h6 className='required fw-normal'>MobileSS Section View</h6>
                                            {/* <p className='text-gray-500'>
                                                        {values[i].componentMobileSS && 'Upload screenshot'}
                                                        {!values[i].componentMobileSS && 'Uplaoded Screenshot'}
                                                        {manualWeb && 'Manually Uploaded'}
                                                    </p> */}
                                        </div>
                                        <div>
                                            <button
                                                type='button'
                                                className={
                                                    !(values.componentMobileSS)
                                                        ? 'btn btn-gray-200 screenshotComponentBtn border border-gray-500'
                                                        : 'screenshotComponentBtn'
                                                }
                                                onClick={() => {
                                                    window.open(values.componentMobileSS, '_blank')
                                                }}
                                                disabled={!values.componentMobileSS}
                                            >
                                                {values.componentMobileSS && (
                                                    <img src={toAbsoluteUrl('/media/icons/Custom/eye.svg')} alt='eye' />
                                                )}
                                                &nbsp; Preview
                                            </button>
                                            {!loadingDesk && (
                                                <button
                                                    type='button'
                                                    className='btn btn-gray-200 screenshotComponentBtn border border-gray-500 w-200px mx-4 cursor-pointer'
                                                    onClick={() => {
                                                        document.getElementById('mobileManual').click()
                                                    }}
                                                >
                                                    Click to {manualMob ? 'Re-Uplaod' : 'Upload'}
                                                </button>
                                            )}
                                            <input
                                                type='file'
                                                accept='.png, .jpg, .jpeg, .svg'
                                                style={{ display: 'none' }}
                                                id={'mobileManual'}
                                                onChange={(e) => onChangeMobile(e)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>


                            {(categoryErr || desktopSsErr || mobileSsErr) && (
                                <div className='fv-plugins-message-container'>
                                    <div className='fv-help-block'>
                                        <span className='text-danger' role='alert'>
                                            Fill all the fields.
                                        </span>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className=' mt-6'>
                            <h6 className='required fw-normal'>Desktop Code</h6>
                            <TextArea
                                autoSize={{ minRows: 5 }}
                                placeholder='Code goes here'
                                onChange={(e) => {
                                    setValues({ ...values, desktopCode: e.target.value })
                                    setDesktopCodeErr(false)
                                }}
                                value={values.desktopCode}
                                className={clsx(
                                    'text-gray-500 form-control form-control-solid rounded-4 bg-gray-100 p-0 border-0 categorySelect p-3'
                                )}
                                style={{
                                    height: '45px',
                                }}
                            />
                            {
                                desktopCodeErr && (
                                    <div className='fv-plugins-message-container'>
                                        <div className='fv-help-block'>
                                            <span className='text-danger' role='alert'>
                                                Desktop COde is Required
                                            </span>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                        <div className=' mt-6'>
                            <h6 className='required fw-normal'>Tablet Code</h6>
                            <TextArea
                                autoSize={{ minRows: 5 }}
                                onChange={(e) => {
                                    setValues({ ...values, tabletCode: e.target.value })
                                    setTabletCodeErr(false)
                                }
                                }
                                value={values.tabletCode}
                                placeholder='Code goes here'
                                className={clsx(
                                    'text-gray-500 form-control form-control-solid rounded-4 bg-gray-100 p-0 border-0 categorySelect p-3'
                                )}
                                style={{
                                    height: '45px',
                                }}
                            />
                            {
                                tabletCodeErr && (
                                    <div className='fv-plugins-message-container'>
                                        <div className='fv-help-block'>
                                            <span className='text-danger' role='alert'>
                                                Tablet COde is Required
                                            </span>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                        <div className=' mt-6'>
                            <h6 className='required fw-normal'>Mobile Code</h6>
                            <TextArea
                                autoSize={{ minRows: 5 }}
                                placeholder='Code goes here'
                                onChange={(e) => {
                                    setValues({ ...values, mobileCode: e.target.value })
                                    setMobileCodeErr(false)
                                }}
                                value={values.mobileCode}
                                className={clsx(
                                    'text-gray-500 form-control form-control-solid rounded-4 bg-gray-100 p-0 border-0 categorySelect p-3'
                                )}
                                style={{
                                    height: '45px',
                                }}
                            />
                            {
                                mobileCodeErr && (
                                    <div className='fv-plugins-message-container'>
                                        <div className='fv-help-block'>
                                            <span className='text-danger' role='alert'>
                                                Mobile COde is Required
                                            </span>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                        <div className='mt-6'>
                            <div className="row">
                                <div className="col">
                                    <p className='required'>Section Phrases (comma separated values)</p>
                                    <Input
                                        type='text'
                                        placeholder='Enter Phrase separted by comma (Press enter to add phrase)'
                                        className='form-control-solid rounded-6 border shadow-none pe-6 mb-5 form-control-solid'
                                        onChange={(e) => {
                                            console.log(e)
                                            setPhraseInput(e.target.value)
                                        }
                                        }
                                        name='phraseInput'
                                        onKeyUp={e => {
                                            e.preventDefault()
                                            if (e.key == 'Enter') {
                                                if (phraseInput.length <= 0) return;
                                                const arr = [...values.componentPhrases]
                                                arr.push(phraseInput)
                                                setPhraseInput('')
                                                setValues({ ...values, componentPhrases: arr })
                                                setPhrasesErr(false)

                                            }
                                        }}
                                        value={phraseInput}
                                        prefix={
                                            <>
                                                <img src={toAbsoluteUrl('/media/icons/Custom/Search.svg')} alt='link' />
                                            </>
                                        }
                                    />
                                    {
                                        phrasesErr && (
                                            <div className='fv-plugins-message-container'>
                                                <div className='fv-help-block'>
                                                    <span className='text-danger' role='alert'>
                                                        Minimum one phrase is Required
                                                    </span>
                                                </div>
                                            </div>
                                        )
                                    }

                                </div>
                            </div>
                            <div className='row pt-4 pe-5 '>
                                <div className='col d-flex flex-row  justify-content-start align-items-center flex-wrap'>
                                    {values.componentPhrases &&
                                        values.componentPhrases?.map((x, ind) => {
                                            return (
                                                <div className='d-flex align-items-center justify-content-around border px-3 py-2 m-2 rounded-pill'>
                                                    {x}
                                                    <img
                                                        style={{ paddingLeft: '5px', cursor: 'pointer', display: 'inline' }}
                                                        onClick={() => {
                                                            const arr = [...values.componentPhrases]
                                                            arr.splice(ind, 1)
                                                            setValues({ ...values, componentPhrases: arr })
                                                        }}
                                                        src={toAbsoluteUrl('/media/icons/Custom/Cross.svg')}
                                                        alt='cross'
                                                    />
                                                </div>
                                            )
                                        })}
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className='d-flex pt-4 pe-5'>
                        <button
                            type='submit'
                            id='kt_sign_up_submit'
                            className='btn btn-primary ms-5 CompanyDetailButton'
                            onClick={() => {
                                submitForm()
                            }}
                            disabled={loading || submitError}
                        >
                            {!loading && <span className='indicator-label'>Save</span>}
                            {loading && (
                                <span className='indicator-progress' style={{ display: 'block' }}>
                                    Please wait...{' '}
                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                            )}
                        </button>
                        {/* <button onClick={skipStep} className='btn btn-primary ms-5 CompanyDetailButton'>
            <span className='indicator-label'>Skip</span>
          </button> */}
                        <Link
                            to={{
                                pathname: '/website/add-components',
                            }}
                        >
                            <button type='button' className='btn fw-bolder btn-gray-200 ms-5 CompanyDetailButton'>
                                Back
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default AddComponentFigmaComp